const comments = [
  {
    name: '追剧小达人',
    time: '2小时前',
    content: '快看影视真的太好用了！画质清晰不卡顿，更新速度也超快，《长相思》刚播完这边就有了，追剧党的福音！',
    rating: 5,
    drama: '在看《长相思》',
  },
  {
    name: '夜深人不静',
    time: '5小时前',
    content: '用了半年多了，片库越来越全。最近在追《莲花楼》，悬疑推理太上头了，每天晚上都舍不得关。推荐给所有爱看剧的朋友！',
    rating: 5,
    drama: '在看《莲花楼》',
  },
  {
    name: '小甜饼爱好者',
    time: '8小时前',
    content: '在这里看完了《偷偷藏不住》全集，赵露思太甜了！流畅度没话说，地铁上也能秒开高清。唯一的烦恼就是好看的剧太多，追不过来~',
    rating: 5,
    drama: '在看《偷偷藏不住》',
  },
  {
    name: '古装剧十级学者',
    time: '1天前',
    content: '《长风渡》和《七时吉祥》连着看太爽了！画质清晰得能看到演员的微表情，关键是全部免费，良心平台必须支持。',
    rating: 4,
    drama: '在看《长风渡》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          追剧心声
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          来自追剧小伙伴的真实反馈
        </p>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((cmt, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-bold text-sm flex-shrink-0">
                  {cmt.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">{cmt.name}</p>
                  <p className="text-xs text-foreground-500">
                    {cmt.time} · {cmt.drama}
                  </p>
                </div>
                <span className="flex items-center gap-0.5 flex-shrink-0">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <i
                      key={j}
                      className={`text-xs ${
                        j < cmt.rating
                          ? 'ri-star-fill text-accent-500'
                          : 'ri-star-line text-foreground-300'
                      }`}
                    ></i>
                  ))}
                </span>
              </div>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {cmt.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}